


import axios from 'axios';

let actucontroller ;
export const  axios_googleapis_geteventsbyclientid= async ({email, id})=>{
    console.log('axios_googleapis_geteventsbyclientid called with id:', email ,id);
    actucontroller && actucontroller.abort() ;
    const controller = new AbortController();
    actucontroller = controller ;
    const toto = await   axios.post('/googleapis/geteventsbyclientid',{email,id},{signal: controller.signal},{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}})
    return toto ;
}


export const  axios_googleapis_updateevent = async (rdv)=>{
    return await   axios.post('/googleapis/updateevent',{...rdv},{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}})
}

export const  axios_googleapis_sentevent = async (rdv)=>{
    return await   axios.post('/googleapis/sentevent',{...rdv},{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}})
}


export const  axios_googleapis_getevents= async (email)=>{
    return await   axios.post('/googleapis/getevents',{email},{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}})
}


export const  axios_googleapis_deleteevent= async ({id ,email})=>{
    console.log('axios_googleapis_deleteevent called with id:', id ,email);
    return await  axios.post(  `/googleapis/deleteevent`,{id ,email},{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}});
}

export const  axios_googleapis_getrefreshtoken= async (code)=>{
    return await  axios.post( `/googleapis/getrefreshtoken`,{code},{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}}) ;
}



